export const appBarHeight = 64;
const drawerWidth = 240;

export const styles = theme => ({
  main: {
    display: 'block',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginTop: `calc(${appBarHeight + 26}px )`
  },
  toolbarWrapper: {
    paddingLeft: 40
  },
  gridWrapper: {
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  addButton: {
    background: 'transparent',
    boxShadow: 'none',
    color: '#8CA0B3',
    fontSize: 14,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: 'transparent'
    },
    '&:disabled': {
      backgroundColor: 'transparent',
      color: '#8CA0B3'
    }
  },
  deleteContainer: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  paper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    marginBottom: 25
  },
  actions: {
    display: 'inline-flex',
    justifyContent: 'cemter',
    alignItems: 'center',
    paddingRight: 20
  },
  spacer: {
    flexGrow: 1
  },
  addText: {
    color: '#8CA0B3',
    fontSize: 15
  },
  FormPaper: {
    display: 'flex',
    alignItems: 'left',
    justifyContent: 'center',
    flexDirection: 'column',
    marginBottom: 25,
    paddingBottom: 30
  },
  FirstFormPaper: {
    display: 'flex',
    alignItems: 'left',
    justifyContent: 'center',
    flexDirection: 'column',
    marginBottom: 25,
    paddingBottom: 30,
    paddingTop: 15,
    marginTop: 150
  },
  toolbar: {
    height: 300
  },
  papperWraper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: '100%',
    marginTop: 20
  },
  title:
  {
    flex: 'auto',
    color: '#697B8C',
    fontSize: 20,
    fontWeight: 'bold'
  },
  form: {
    width: '100%',
    textAlign: 'center',
    marginTop: theme.spacing(1)
  },
  button: {
    backgroundColor: '#2797E8',
    color: 'white',
    fontSize: 14,
    fontWeight: 'normal',
    margin: 10,
    marginRight: 40,
    paddingLeft: 40,
    paddingRight: 40,
    paddingTop: 10,
    paddingBottom: 10
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3)
  },
  container: {
    display: 'block',
    flexWrap: 'wrap',
    justifyContent: 'center'
  },
  input: {
    width: '100%',
    maxWidth: 500,
    marginRight: theme.spacing(2)
  },
  labelInput: {
    color: '#8CA0B3',
    fontSize: 18
  },
  textInput: {
    color: '#697B8C',
    fontWeight: 500,
    fontSize: 14
  },
  inputWrapper: {
    paddingLeft: 20,
    paddingRight: 20
  },
  gridContainer:
  {
    width: '100%',
    paddingLeft: 28,
    margin: 0
  },
  divider: {
    marginBottom: 10,
    width: '95%'
  },
  wrapDivider: {
    justifyContent: 'center'
  },
  appBar: {
    marginTop: 90,
    display: 'flex',
    right: 'auto',
    [theme.breakpoints.up('md')]: {
      width: `calc(100% - (${drawerWidth}px + 65px))`
    },
    background: '#FFFFFF'
  },
  observationsInput: {
    width: '100%',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2)
  }
});
